import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useLanguage } from '../context/LanguageContext';

const colazioneCtx = require.context('../images/colazione', false, /\.(png|jpe?g|svg)$/);
// Show only first 2 photos as teaser — full gallery is on /colazione page
const previewImages = colazioneCtx.keys().slice(0, 2).map(k => colazioneCtx(k));

function Breakfast() {
    const { isEnLang } = useLanguage();
    const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.15 });

    const text = {
        en: {
            label: 'Included in your stay',
            title: 'Start the Day Right',
            description: 'Every morning we prepare a welcoming breakfast with fresh pastries, coffee, hot drinks and seasonal products. A warm moment of flavour to begin each day of your holiday.',
            link: 'Discover our breakfast',
        },
        it: {
            label: 'Inclusa nel soggiorno',
            title: 'Inizia la Giornata nel Modo Giusto',
            description: "Ogni mattina prepariamo una colazione accogliente con pasticceria fresca, caffè, bevande calde e prodotti di stagione. Un momento di calore e sapore per iniziare ogni giornata del tuo soggiorno.",
            link: 'Scopri la colazione',
        },
    };

    const { label, title, description, link } = isEnLang ? text.en : text.it;

    return (
        <motion.section
            ref={ref}
            id="breakfast"
            className="breakfast l-1260"
            initial={{ opacity: 0, y: 50 }}
            animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
            transition={{ duration: 0.8 }}
        >
            <div className="breakfast-text">
                <span className="breakfast-label">{label}</span>
                <h2>{title}</h2>
                <p>{description}</p>
                <Link to="/colazione" className="breakfast-link">{link} →</Link>
            </div>
            <div className="breakfast-photos">
                {previewImages.map((src, i) => (
                    <img
                        key={i}
                        src={src}
                        alt={isEnLang
                            ? `Breakfast at B&B Alma Suite Anzio ${i + 1}`
                            : `Colazione al B&B Alma Suite Anzio ${i + 1}`}
                    />
                ))}
            </div>
        </motion.section>
    );
}

export default Breakfast;
